import React from 'react';
import { Trash2 } from 'lucide-react';
import { Plus } from 'lucide-react';
import { ErrorMessage } from './ErrorMessage';

const LineItemForm = ({ register, fields, addLineItem, errors }) => {
   return (
      <>
         <div className="bg-slate-900/50 backdrop-blur-sm rounded-2xl border border-slate-800 relative z-0">
            <div className="p-5 border-b border-slate-800 flex items-center justify-between">
               <div>
                  <h2 className="text-sm font-semibold text-white">Line Items</h2>
                  {errors.lineItems?.message && <ErrorMessage message={errors.lineItems.message} />}
               </div>
               <button
                  type="button"
                  onClick={addLineItem}
                  className="px-3 py-1.5 rounded-lg bg-blue-600 hover:bg-blue-500 transition-all text-xs font-medium flex items-center gap-1.5 text-white">
                  <Plus className="w-3.5 h-3.5" />
                  Add Item
               </button>
            </div>

            <div className="p-5">
               <div
                  className="overflow-x-auto overflow-y-auto max-h-[500px]"
                  style={{
                     scrollbarWidth: 'thin',
                     scrollbarColor: 'rgba(71, 85, 105, 0.5) transparent',
                  }}>
                  <table className="w-full">
                     <thead>
                        <tr className="border-b border-slate-700/50 bg-slate-900/50">
                           <th className="text-center px-4 py-4 text-xs font-semibold text-slate-300 uppercase tracking-wider">
                              No.
                           </th>
                           <th className="text-center px-4 py-4 text-xs font-semibold text-slate-300 uppercase tracking-wider">
                              Action
                           </th>
                           <th className="text-left px-4 py-4 text-xs font-semibold text-slate-300 uppercase tracking-wider min-w-36">
                              Warehouse
                           </th>
                           <th className="text-left px-4 py-4 text-xs font-semibold text-slate-300 uppercase tracking-wider min-w-96">
                              Item
                           </th>
                           <th className="text-left px-4 py-4 text-xs font-semibold text-slate-300 uppercase tracking-wider min-w-36">
                              Type of Supply
                           </th>
                           <th className="text-left px-4 py-4 text-xs font-semibold text-slate-300 uppercase tracking-wider min-w-32">
                              Unit
                           </th>
                           <th className="text-right px-4 py-4 text-xs font-semibold text-slate-300 uppercase tracking-wider min-w-32">
                              Qty 1
                           </th>
                           <th className="text-right px-4 py-4 text-xs font-semibold text-slate-300 uppercase tracking-wider min-w-32">
                              Qty 2
                           </th>
                           <th className="text-right px-4 py-4 text-xs font-semibold text-slate-300 uppercase tracking-wider min-w-32">
                              Qty 3
                           </th>
                           <th className="text-right px-4 py-4 text-xs font-semibold text-slate-300 uppercase tracking-wider  min-w-32">
                              Rate
                           </th>
                           <th className="text-right px-4 py-4 text-xs font-semibold text-slate-300 uppercase tracking-wider">
                              Amount
                           </th>
                           <th className="text-right px-4 py-4 text-xs font-semibold text-slate-300 uppercase tracking-wider min-w-32">
                              Disc1 (%)
                           </th>
                           <th className="text-right px-4 py-4 text-xs font-semibold text-slate-300 uppercase tracking-wider">
                              Disc AMT 1
                           </th>
                           <th className="text-right px-4 py-4 text-xs font-semibold text-slate-300 uppercase tracking-wider min-w-32">
                              Disc2 (%)
                           </th>
                           <th className="text-right px-4 py-4 text-xs font-semibold text-slate-300 uppercase tracking-wider">
                              Disc AMT 2
                           </th>
                           <th className="text-right px-4 py-4 text-xs font-semibold text-slate-300 uppercase tracking-wider min-w-32">
                              Disc3 (%)
                           </th>
                           <th className="text-right px-4 py-4 text-xs font-semibold text-slate-300 uppercase tracking-wider">
                              Disc AMT 3
                           </th>
                           <th className="text-right px-4 py-4 text-xs font-semibold text-slate-300 uppercase tracking-wider">
                              GST %
                           </th>
                           <th className="text-right px-4 py-4 text-xs font-semibold text-slate-300 uppercase tracking-wider">
                              GST Taxable
                           </th>
                           <th className="text-right px-4 py-4 text-xs font-semibold text-slate-300 uppercase tracking-wider">
                              GST Amt
                           </th>
                           <th className="text-right px-4 py-4 text-xs font-semibold text-slate-300 uppercase tracking-wider">
                              Amt + GST
                           </th>
                        </tr>
                     </thead>
                     <tbody className="divide-y divide-slate-700/30">
                        {fields.map((item, index) => (
                           <tr key={index} className="group hover:bg-slate-700/20 transition-colors duration-150">
                              <td className="px-4 py-4 text-right">
                                 <span className="text-sm font-bold text-emerald-400">{index + 1}</span>
                              </td>
                              <td className="px-4 py-4 text-center">
                                 {new Array(10).length > 1 && (
                                    <button
                                       // onClick={() => removeItem(item.id)}
                                       className="opacity-0 group-hover:opacity-100 p-2 hover:bg-red-500/20 rounded-lg transition-all duration-200 inline-flex items-center justify-center"
                                       title="Delete item">
                                       <Trash2 className="w-4 h-4 text-red-400 hover:text-red-300" />
                                    </button>
                                 )}
                              </td>
                              <td className="px-4 py-4">
                                 <select
                                    id={`warehouse-${index}`}
                                    {...register(`lineItems.${index}.warehouseId`, {
                                       valueAsNumber: true,
                                       //    onChange: (e) => calculateLineItem(index, 'itemId', e.target.value),
                                    })}
                                    value={item.warehouse}
                                    // onChange={(e) =>
                                    //   calculateItem(
                                    //     index,
                                    //     "warehouse",
                                    //     e.target.value
                                    //   )
                                    // }
                                    className="w-full bg-slate-900/60 border border-slate-600/50 hover:border-slate-500 focus:border-blue-500 rounded-lg px-3 py-2 text-sm text-white placeholder-slate-500 transition-all duration-200 focus:ring-2 focus:ring-blue-500/20 focus:outline-none">
                                    <option value="">Warehouse...</option>
                                    <option value="raw">Raw</option>
                                    <option value="finished">Finished</option>
                                 </select>
                                 {errors.lineItems?.[index]?.warehouseId && (
                                    <ErrorMessage message={errors.lineItems?.[index]?.warehouseId?.message} />
                                 )}
                              </td>
                              <td className="px-4 py-4">
                                 <select
                                    id={`item-${index}`}
                                    {...register(`lineItems.${index}.itemId`, {
                                       valueAsNumber: true,
                                       //    onChange: (e) => calculateLineItem(index, 'itemId', e.target.value),
                                    })}
                                    // onChange={(e) =>
                                    //   calculateItem(index, "item", e.target.value)
                                    // }
                                    // className="w-full bg-slate-900/60 border border-slate-600/50 hover:border-slate-500 focus:border-blue-500 rounded-lg px-3 py-2 text-sm text-white placeholder-slate-500 transition-all duration-200 focus:ring-2 focus:ring-blue-500/20 focus:outline-none"
                                    className={`w-full bg-slate-800/50 border ${
                                       errors.lineItems?.[index]?.itemId ? 'border-red-500' : 'border-slate-700'
                                    } rounded-lg px-3 py-2 text-sm text-white focus:ring-2 focus:ring-blue-500 transition-all`}>
                                    <option>Item...</option>
                                    <option value="item1">Product A</option>
                                    <option value="item2">Product B</option>
                                 </select>
                                 {errors.lineItems?.[index]?.itemId && (
                                    <ErrorMessage message={errors.lineItems?.[index]?.itemId?.message} />
                                 )}
                              </td>
                              <td className="px-4 py-4">
                                 <select
                                    id={`typeOfSupply-${index}`}
                                    {...register(`lineItems.${index}.typeOfSupply`, {
                                       valueAsNumber: true,
                                       //    onChange: (e) => calculateLineItem(index, 'typeOfSupply', e.target.value),
                                    })}
                                    // onChange={(e) =>
                                    //   calculateItem(index, "item", e.target.value)
                                    // }
                                    // className="w-full bg-slate-900/60 border border-slate-600/50 hover:border-slate-500 focus:border-blue-500 rounded-lg px-3 py-2 text-sm text-white placeholder-slate-500 transition-all duration-200 focus:ring-2 focus:ring-blue-500/20 focus:outline-none"
                                    className={`w-full bg-slate-800/50 border ${
                                       errors.lineItems?.[index]?.typeOfSupply ? 'border-red-500' : 'border-slate-700'
                                    } rounded-lg px-3 py-2 text-sm text-white focus:ring-2 focus:ring-blue-500 transition-all`}>
                                    <option>Type Of Supply...</option>
                                    <option value="item1">Product A</option>
                                    <option value="item2">Product B</option>
                                 </select>
                                 {errors.lineItems?.[index]?.typeOfSupply && (
                                    <ErrorMessage message={errors.lineItems?.[index]?.typeOfSupply?.message} />
                                 )}
                              </td>
                              <td className="px-4 py-4">
                                 <select
                                    id={`unit-${index}`}
                                    {...register(`lineItems.${index}.unit`, {
                                       valueAsNumber: true,
                                       //    onChange: (e) => calculateLineItem(index, 'unit', e.target.value),
                                    })}
                                    // onChange={(e) =>
                                    //   calculateItem(index, "item", e.target.value)
                                    // }
                                    // className="w-full bg-slate-900/60 border border-slate-600/50 hover:border-slate-500 focus:border-blue-500 rounded-lg px-3 py-2 text-sm text-white placeholder-slate-500 transition-all duration-200 focus:ring-2 focus:ring-blue-500/20 focus:outline-none"
                                    className={`w-full bg-slate-800/50 border ${
                                       errors.lineItems?.[index]?.unit ? 'border-red-500' : 'border-slate-700'
                                    } rounded-lg px-3 py-2 text-sm text-white focus:ring-2 focus:ring-blue-500 transition-all`}>
                                    <option>Unit...</option>
                                    <option value="item1">Product A</option>
                                    <option value="item2">Product B</option>
                                 </select>
                                 {errors.lineItems?.[index]?.unit && (
                                    <ErrorMessage message={errors.lineItems?.[index]?.unit?.message} />
                                 )}
                              </td>
                              <td className="px-4 py-4">
                                 <input
                                    type="number"
                                    {...register(`lineItems.${index}.qty1`, {
                                       valueAsNumber: true,
                                       // onChange: (e) => calculateLineItem(index, 'itemId', e.target.value)
                                    })}
                                    // onChange={(e) =>
                                    //   calculateItem(index, "qty", e.target.value)
                                    // }
                                    placeholder="0"
                                    // className="w-full bg-slate-900/60 border border-slate-600/50 hover:border-slate-500 focus:border-blue-500 rounded-lg px-3 py-2 text-sm text-white text-right placeholder-slate-500 transition-all duration-200 focus:ring-2 focus:ring-blue-500/20 focus:outline-none"
                                    className={`w-full bg-slate-800/50 border ${
                                       errors.lineItems?.[index]?.qty1 ? 'border-red-500' : 'border-slate-700'
                                    } rounded-lg px-3 py-2 text-sm text-white focus:ring-2 focus:ring-blue-500 transition-all`}
                                 />
                                 {errors.lineItems?.[index]?.qty1 && (
                                    <ErrorMessage message={errors.lineItems?.[index]?.qty1?.message} />
                                 )}
                              </td>
                              <td className="px-4 py-4">
                                 <input
                                    type="number"
                                    {...register(`lineItems.${index}.qty2`, {
                                       valueAsNumber: true,
                                       // onChange: (e) => calculateLineItem(index, 'itemId', e.target.value)
                                    })}
                                    // onChange={(e) =>
                                    //   calculateItem(index, "qty", e.target.value)
                                    // }
                                    placeholder="0"
                                    // className="w-full bg-slate-900/60 border border-slate-600/50 hover:border-slate-500 focus:border-blue-500 rounded-lg px-3 py-2 text-sm text-white text-right placeholder-slate-500 transition-all duration-200 focus:ring-2 focus:ring-blue-500/20 focus:outline-none"
                                    className={`w-full bg-slate-800/50 border ${
                                       errors.lineItems?.[index]?.qty2 ? 'border-red-500' : 'border-slate-700'
                                    } rounded-lg px-3 py-2 text-sm text-white focus:ring-2 focus:ring-blue-500 transition-all`}
                                 />
                                 {errors.lineItems?.[index]?.qty2 && (
                                    <ErrorMessage message={errors.lineItems?.[index]?.qty2?.message} />
                                 )}
                              </td>
                              <td className="px-4 py-4">
                                 <input
                                    type="number"
                                    {...register(`lineItems.${index}.qty3`, {
                                       valueAsNumber: true,
                                       // onChange: (e) => calculateLineItem(index, 'itemId', e.target.value)
                                    })}
                                    // onChange={(e) =>
                                    //   calculateItem(index, "qty", e.target.value)
                                    // }
                                    placeholder="0"
                                    // className="w-full bg-slate-900/60 border border-slate-600/50 hover:border-slate-500 focus:border-blue-500 rounded-lg px-3 py-2 text-sm text-white text-right placeholder-slate-500 transition-all duration-200 focus:ring-2 focus:ring-blue-500/20 focus:outline-none"
                                    className={`w-full bg-slate-800/50 border ${
                                       errors.lineItems?.[index]?.qty3 ? 'border-red-500' : 'border-slate-700'
                                    } rounded-lg px-3 py-2 text-sm text-white focus:ring-2 focus:ring-blue-500 transition-all`}
                                 />
                                 {errors.lineItems?.[index]?.qty3 && (
                                    <ErrorMessage message={errors.lineItems?.[index]?.qty3?.message} />
                                 )}
                              </td>
                              <td className="px-4 py-4">
                                 <input
                                    type="number"
                                    {...register(`lineItems.${index}.itemRate`, {
                                       valueAsNumber: true,
                                       // onChange: (e) => calculateLineItem(index, 'itemId', e.target.value)
                                    })}
                                    // onChange={(e) =>
                                    //   calculateItem(index, "rate", e.target.value)
                                    // }
                                    placeholder="0"
                                    // className="w-full bg-slate-900/60 border border-slate-600/50 hover:border-slate-500 focus:border-blue-500 rounded-lg px-3 py-2 text-sm text-white text-right placeholder-slate-500 transition-all duration-200 focus:ring-2 focus:ring-blue-500/20 focus:outline-none"
                                    className={`w-full bg-slate-800/50 border ${
                                       errors.lineItems?.[index]?.itemRate ? 'border-red-500' : 'border-slate-700'
                                    } rounded-lg px-3 py-2 text-sm text-white focus:ring-2 focus:ring-blue-500 transition-all`}
                                 />
                                 {errors.lineItems?.[index]?.itemRate && (
                                    <ErrorMessage message={errors.lineItems?.[index]?.itemRate?.message} />
                                 )}
                              </td>
                              <td className="px-4 py-4 text-right">
                                 <span className="text-sm font-bold text-emerald-400">₹1000</span>
                              </td>
                              <td className="px-4 py-4">
                                 <input
                                    type="number"
                                    {...register(`lineItems.${index}.addLess1Percent`, {
                                       valueAsNumber: true,
                                       //    onChange: (e) => calculateLineItem(index, 'addLess1Percent', e.target.value),
                                    })}
                                    // onChange={(e) =>
                                    //   calculateItem(index, "rate", e.target.value)
                                    // }
                                    placeholder="0"
                                    // className="w-full bg-slate-900/60 border border-slate-600/50 hover:border-slate-500 focus:border-blue-500 rounded-lg px-3 py-2 text-sm text-white text-right placeholder-slate-500 transition-all duration-200 focus:ring-2 focus:ring-blue-500/20 focus:outline-none"
                                    className={`w-full bg-slate-800/50 border ${
                                       errors.lineItems?.[index]?.addLess1Percent
                                          ? 'border-red-500'
                                          : 'border-slate-700'
                                    } rounded-lg px-3 py-2 text-sm text-white focus:ring-2 focus:ring-blue-500 transition-all`}
                                 />
                                 {errors.lineItems?.[index]?.addLess1Percent && (
                                    <ErrorMessage message={errors.lineItems?.[index]?.addLess1Percent?.message} />
                                 )}
                              </td>
                              <td className="px-4 py-4 text-right">
                                 <span className="text-sm font-bold text-emerald-400">₹1000</span>
                              </td>
                              <td className="px-4 py-4">
                                 <input
                                    type="number"
                                    {...register(`lineItems.${index}.addLess2Percent`, {
                                       valueAsNumber: true,
                                       //    onChange: (e) => calculateLineItem(index, 'addLess2Percent', e.target.value),
                                    })}
                                    // onChange={(e) =>
                                    //   calculateItem(index, "rate", e.target.value)
                                    // }
                                    placeholder="0"
                                    // className="w-full bg-slate-900/60 border border-slate-600/50 hover:border-slate-500 focus:border-blue-500 rounded-lg px-3 py-2 text-sm text-white text-right placeholder-slate-500 transition-all duration-200 focus:ring-2 focus:ring-blue-500/20 focus:outline-none"
                                    className={`w-full bg-slate-800/50 border ${
                                       errors.lineItems?.[index]?.addLess2Percent
                                          ? 'border-red-500'
                                          : 'border-slate-700'
                                    } rounded-lg px-3 py-2 text-sm text-white focus:ring-2 focus:ring-blue-500 transition-all`}
                                 />
                                 {errors.lineItems?.[index]?.addLess2Percent && (
                                    <ErrorMessage message={errors.lineItems?.[index]?.addLess2Percent?.message} />
                                 )}
                              </td>
                              <td className="px-4 py-4 text-right">
                                 <span className="text-sm font-bold text-emerald-400">₹1000</span>
                              </td>
                              <td className="px-4 py-4">
                                 <input
                                    type="number"
                                    {...register(`lineItems.${index}.addLess3Percent`, {
                                       valueAsNumber: true,
                                       //    onChange: (e) => calculateLineItem(index, 'addLess3Percent', e.target.value),
                                    })}
                                    // onChange={(e) =>
                                    //   calculateItem(index, "rate", e.target.value)
                                    // }
                                    placeholder="0"
                                    // className="w-full bg-slate-900/60 border border-slate-600/50 hover:border-slate-500 focus:border-blue-500 rounded-lg px-3 py-2 text-sm text-white text-right placeholder-slate-500 transition-all duration-200 focus:ring-2 focus:ring-blue-500/20 focus:outline-none"
                                    className={`w-full bg-slate-800/50 border ${
                                       errors.lineItems?.[index]?.addLess3Percent
                                          ? 'border-red-500'
                                          : 'border-slate-700'
                                    } rounded-lg px-3 py-2 text-sm text-white focus:ring-2 focus:ring-blue-500 transition-all`}
                                 />
                                 {errors.lineItems?.[index]?.addLess3Percent && (
                                    <ErrorMessage message={errors.lineItems?.[index]?.addLess3Percent?.message} />
                                 )}
                              </td>
                              <td className="px-4 py-4 text-right">
                                 <span className="text-sm font-bold text-emerald-400">₹1000</span>
                              </td>
                              <td className="px-4 py-4">
                                 <span className="text-sm font-bold text-emerald-400">₹1000</span>
                              </td>
                              <td className="px-4 py-4 text-right">
                                 <span className="text-sm font-semibold text-slate-200">₹1000</span>
                              </td>
                              <td className="px-4 py-4 text-right">
                                 <span className="text-sm font-semibold text-cyan-400">₹100</span>
                              </td>
                              <td className="px-4 py-4 text-right">
                                 <span className="text-sm font-bold text-emerald-400">₹1000</span>
                              </td>
                           </tr>
                        ))}
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
      </>
   );
};

export default LineItemForm;
